import { hasValue } from '../helpers';
export class AvatarControllerModel {
    avatar = null;
    loadAvatar;
    onChangeAvatar;
    _avatarChanged = false;
    constructor(logService, webClientService, receiver) {
        const log = logService.getLogger('Avatar-CM');
        this.loadAvatar = new Promise((resolve, reject) => {
            if (!hasValue(receiver)) {
                log.debug('No receiver defined, no avatar');
                resolve(null);
                return;
            }
            else if (!hasValue(receiver.avatar) || !hasValue(receiver.avatar.high)) {
                log.debug('Requesting high res avatar from app');
                webClientService.requestAvatar(receiver, true)
                    .then((data) => resolve(data))
                    .catch((error) => reject(error));
            }
            else {
                log.debug('Returning cached avatar');
                resolve(receiver.avatar.high);
            }
        });
        this.onChangeAvatar = (image) => {
            this.avatar = image;
            this._avatarChanged = true;
        };
    }
    getAvatar() {
        return this.avatar;
    }
    get avatarChanged() {
        return this._avatarChanged;
    }
}
